module.exports = __webpack_public_path__ + "static/steuerberatung-srd2-d491bcec5bac9ca4cba5be275dde2618.jpg";